import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=cdf45a08&scoped=true"
import script from "./TagEditor.vue?vue&type=script&lang=js"
export * from "./TagEditor.vue?vue&type=script&lang=js"
import style0 from "./TagEditor.vue?vue&type=style&index=0&id=cdf45a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf45a08",
  null
  
)

export default component.exports